import { Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from 'src/services/services.service';

export interface EventElement {
  user: string;
  points: string;
  status: string;
  date: string;
  action: any;
}

@Component({
  selector: 'app-redeemrequests',
  templateUrl: './redeemrequests.component.html',
  styleUrls: ['./redeemrequests.component.scss']
})
export class RedeemrequestsComponent {

  displayedColumns: string[] = [
    'user',
    'points',
    'status',
    'date',
    'action'
  ];

  filteredRequests: any[] = [];
  ELEMENT_DATA: EventElement[] = [];
  private destroyRef = inject(DestroyRef);
  dataSource = new MatTableDataSource<EventElement>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const so_id = params['so_id'];
      if (so_id) {
        this.getRedeemRequests(so_id);
      }
    });
  }


  redeemRequests: any[] = [];

  pendingCount = 0;
  approvedCount = 0;
  totalPoints = 0;

  getRedeemRequests(so_id: any) {

    this.service.getRedeemRequests(so_id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {

      this.redeemRequests = res.data || [];
      this.filteredRequests = [...this.redeemRequests];

      this.pendingCount =
        this.redeemRequests.filter(x => x.type === 'pending').length;

      this.approvedCount =
        this.redeemRequests.filter(x => x.type === 'debit').length;

      this.totalPoints =
        this.redeemRequests.reduce(
          (sum, x) => sum + Number(x.points),
          0
        );

      for (const item of this.redeemRequests) {
        this.ELEMENT_DATA.push({
          user: item.user_name,
          points: item.points,
          status: item.type,
          date: item.created_date,
          action: item
        });
      }
      this.dataSource = new MatTableDataSource(this.redeemRequests);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  approveRequest(item: any) {
    console.log('approve', item);
    this.service.approveRedeemRequest(item.id, 'approve').pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      // Handle success response
      window.location.reload();
    });
  }

  rejectRequest(item: any) {
    console.log('reject', item);
    this.service.approveRedeemRequest(item.id, 'reject').pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
      // Handle success response
      window.location.reload();
    });
  }
  applyFilter(event: Event): void {

    const value = (event.target as HTMLInputElement)
      .value
      .trim()
      .toLowerCase();

    if (!value) {
      this.filteredRequests = [...this.redeemRequests];
      return;
    }

    this.filteredRequests =
      this.redeemRequests.filter(item =>
        item.user_id.toString().includes(value) ||
        item.type.toLowerCase().includes(value)
      );
  }
}
